import "./AboutUs2.module.css";
import Header from "@/reusable_sections/Header";
import HeroBanner from "./sections/HeroBanner";
import AboutUs from "./sections/AboutUs";
import Mission from "./sections/Mission";
import Vision from "./sections/Vision";
import CodeOfEthics from "./sections/CodeOfEthics";
import Culture from "./sections/Culture";
import Talent from "./sections/Talent";
import News from "./sections/News";
import Footer from "@/reusable_sections/Footer";
import AboutUsCopy from "./sections/AboutUsCopy";
export default function AboutUs2Page() {
  return <div>
      <Header />
      <HeroBanner />
      <AboutUs />
      <AboutUsCopy />
      <Mission />
      <Vision />
      <CodeOfEthics />
      <Culture />
      <Talent />
      <News />
      <Footer />
    </div>;
}